export default function splitTimerTime(totalSeconds: number):{minutes: string, seconds: string} {
    const minutesPart = Math.floor(totalSeconds / 60);
    const secondsPart = totalSeconds - (minutesPart * 60);
    const secondsPartFormatted = secondsPart < 10 ? '0' + String(secondsPart) : String(secondsPart);
    return {minutes: minutesPart.toString(), seconds: secondsPartFormatted};
}
